import { inject } from '@angular/core'
import { CanActivateFn, CanMatchFn, Router } from '@angular/router'
import { FeatureFlagService } from 'src/app/@core/services/feature-flag/feature-flag.service'

// Com a flag desligada, a Gestão não existe: quem chegar em /gestao volta
// para o dashboard.
export const managementCockpitGuard: CanActivateFn & CanMatchFn = () => {
  if (inject(FeatureFlagService).isEnabled('managementCockpit')) {
    return true
  }

  return inject(Router).createUrlTree(['/dashboard'])
}
